import DotNet from '@/class/dotnet'
import forge from 'node-forge'

export default class Authorize extends DotNet {

    private user: string
    private password: string
    private pemKey?: string
    private randomKey?: string
    private channel: string

    constructor(httpClient: any, user: string, password: string) {

        super(httpClient)
        this.user = user
        this.password = password
        this.channel = 'offline'
    }

    public login() {

        return this.httpClient.request({
            url: this.authPublicKey,
            method: 'get'
        })
        .then((response: any) => {

            this.pemKey = response.data.key[0].publicPEM
            this.randomKey = response.data.key[0].randomKey
        })
        .then(() => this.encryptKeys())
    }

    private encryptKeys() {

        const forge_public_key = forge.pki.publicKeyFromPem(this.pemKey)
        const encrypted = forge_public_key.encrypt(`key:${this.randomKey}|user:${this.user}|password:${this.password}|channel:${this.channel}`, 'RSA-OAEP', {
            md: forge.md.sha1.create()
        })

        return forge.util.encode64(encrypted)
    }
}